<template>
    <modal :show.sync=show :hide-footer="true" :modalClasses="{ 'calculator-modal': true, 'medium-sized-modal': Object.keys(tableData).length === 0}" @close="resetForm()">
        <h3 slot="header" class="mb-0 font-weight-500">Refinance Calculator</h3>
        <div v-loading="loading">
            <div v-show="Object.keys(tableData).length === 0">
                <ValidationObserver v-slot="{ invalid }" ref="observer">
                    <b-form ref="refinanceForm" role="form" @submit.prevent="calculate()">
                        <b-row>
                            <b-col cols="12" md="6">
                                <b-form-group label="Customer Age">
                                    <ValidationProvider
                                        v-slot="{ errors }"
                                        :rules="{ required: true }"
                                        :vid="'age'"
                                    >
                                    <b-form-input
                                        v-model="form.age"
                                        type="text"
                                        minlength="1"
                                        maxlength="3"
                                        @keydown="preventNonNumericInput"
                                        required
                                        ></b-form-input>
                                        <small v-if="errors[0]" class="text-danger">{{ errors[0] }}</small>
                                    </ValidationProvider>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="6">
                                <b-form-group label="Property Value">
                                    <ValidationProvider
                                        v-slot="{ errors }"
                                        :rules="{ required: true }"
                                        :vid="'propertyValue'"
                                    >
                                        <CurrencyInput
                                            v-model="form.property_value"
                                            :options="{ currency: 'MYR', currencyDisplay: 'hidden', autoDecimalDigits: true }"
                                        />
                                        <small v-if="errors[0]" class="text-danger">{{ errors[0] }}</small>
                                    </ValidationProvider>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="6">
                                <b-form-group label="Commitment Amount">
                                    <ValidationProvider
                                        v-slot="{ errors }"
                                        :rules="{ required: true }"
                                        :vid="'interest'"
                                    >
                                        <b-form-input
                                        v-model="form.commitment_amount"
                                        type="text"
                                        @keydown="preventNonNumericInput"
                                        required
                                        ></b-form-input>
                                        <small v-if="errors[0]" class="text-danger">{{ errors[0] }}</small>
                                    </ValidationProvider>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="6">
                                <b-form-group label="Bank Outstanding">
                                    <ValidationProvider
                                        v-slot="{ errors }"
                                        :rules="{ required: true }"
                                        :vid="'bankOutstanding'"
                                    >
                                        <b-form-input
                                        v-model="form.bank_outstanding"
                                        type="text"
                                        @keydown="preventNonNumericInput"
                                        required
                                        ></b-form-input>
                                        <small v-if="errors[0]" class="text-danger">{{ errors[0] }}</small>
                                    </ValidationProvider>
                                </b-form-group>
                            </b-col>
                        </b-row>
        
                        <b-row>
                            <b-col md="6" sm="12" class="mx-auto text-center mt-4 pt-2">
                                <b-button type="submit" variant="primary" :disabled="invalid">Calculate</b-button>
                                <b-button variant="primary" @click.prevent="resetForm">Reset</b-button>
                            </b-col>
                        </b-row>
                    </b-form>
                </ValidationObserver>
            </div>
            <div v-show="Object.keys(tableData).length > 0">
                <RefinanceCalculatorTable v-show="Object.keys(tableData).length > 0" :tableData="tableData" />
            </div>
        </div>
    </modal>
</template>
<script>
import Modal from '@/components/Modal'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import '@/assets/js/formValidations.js'
import CurrencyInput from '@/components/CurrencyInput'
import {
    notifyFunctionMixin,
    helperFunctionMixin,
    axios,
    services,
    getHeader
} from '@/assets/js/httpImports.js'
import RefinanceCalculatorTable from '@/views/Calculators/CalculatorsTables/RefinanceCalculatorTable'

export default {
    props: {
        refinance_calculator: Boolean
    },
    mixins:[ notifyFunctionMixin, helperFunctionMixin ],
    components: {
        Modal,
        ValidationObserver,
        ValidationProvider,
        CurrencyInput,
        RefinanceCalculatorTable,
    },
    data() {
        return {
            loading: false,
            form: {
                age: 30,
                property_value: 500000,
                commitment_amount: 0,
                bank_outstanding: 30000,
            },
            tableData: {},
        }
    },
    computed: {
        show: {
            get() {
                return this.refinance_calculator;
            },
            set(newVal) {
                this.$emit('update:refinance_calculator', newVal);
            },
        },
    },
    methods: {
        preventNonNumericInput(event) {
            const keyCode = event.keyCode || event.which;
            const keyValue = String.fromCharCode(keyCode);
            const currencyRegex = /^[\d.,$]+(\.[\d.,$]+)?$/;
            const allowedKeys = [8, 37, 38, 39, 40, 46];
            if (keyCode !== 190 && !currencyRegex.test(keyValue) && !allowedKeys.includes(keyCode)) {
                event.preventDefault();
            }
        },
        calculate() {
            this.loading = true
            let requestData = {
                age: this.form.age,
                property_value: this.form.property_value,
                commitment_amount: this.form.commitment_amount,
                bank_outstanding: this.form.bank_outstanding,
            }

            let url = 'https://gateway-demo.fintos.com.my/calculator/refinance-loan'
            
			axios.post(url, requestData, { headers: getHeader() })
			.then(res => {
                this.tableData = res.data
                this.loading = false
			})
			.catch(e => {
				this.errorFunction(e)
			})
        },
        resetForm() {
            this.form = {
                age: 30,
                property_value: 500000,
                commitment_amount: 0,
                bank_outstanding: 30000,
            }
            this.tableData = {}
        }
    }
}
</script>